import base from '../dr-base'
import drCheckbox from './dr-checkbox.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-checkbox',
  name: 'Check box',
  group: 'Input widgets',
  icon: 'check-square',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-checkbox.disabled',
      type: 'string',
      default: ''
    },
    Required: {
      name: 'vuetifyWidgets.general.required',
      type: 'boolean'
    },
    Caption: {
      name: 'vuetifyWidgets.dr-checkbox.caption',
      type: 'string',
      default: ''
    },
    CaptionPosition: {
      name: 'vuetifyWidgets.dr-checkbox.captionPosition',
      type: 'string',
      default: 'right',
      enum: [{
        value: 'left',
        text: 'vuetifyWidgets.dr-checkbox.left'
      }, {
        value: 'right',
        text: 'vuetifyWidgets.dr-checkbox.right'
      }]
    },
    Value: {
      name: 'vuetifyWidgets.dr-checkbox.value',
      type: 'string',
      default: '',
      component: 'dr-value-editor'
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-checkbox.generationOnChange'
    },
    switchMode: {
      name: 'vuetifyWidgets.dr-checkbox.switchMode',
      type: 'boolean',
      default: false
    }
  }
}

export default {
  schema,
  component: drCheckbox,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
